var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnAlphahq = function SvgIcnAlphahq(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.951 6.234c.018.127.036.254.036.363a6.972 6.972 0 0 1-.711 3.562.673.673 0 0 1-.996.364c-.322-.132-.352-.324-.408-.685a19.701 19.701 0 0 0-.018-.115c-.142-1.163-.427-2.253-.711-3.344h-.071a33.99 33.99 0 0 0-3.84-.218h-1.28c-.213 0-.213-.363 0-.363 1.636 0 3.342 0 4.977-.218-.127-.478-.28-.956-.428-1.419-.1-.311-.197-.615-.283-.908-.12-.308-.228-.616-.334-.919-.144-.411-.284-.812-.448-1.189-.07-.072.071-.145.143-.145a6.522 6.522 0 0 1 2.986 2.035c.07.146.213.364.284.437.036.036.071.09.107.145.035.054.07.109.107.145.142.146.213.291.284.436.035.11.089.219.142.328.053.109.107.218.142.327.071.145.143.29.143.363.07.146.142.436.142.654 0 .11.018.237.035.364Zm-1.244 2.035a6.4 6.4 0 0 0 .427-1.672v-.654c0-.654-.143-1.381-.427-1.963a.562.562 0 0 0-.142-.363 5.316 5.316 0 0 0-1.138-1.381c0-.049-.063-.097-.126-.146-.032-.024-.063-.048-.087-.072-.142-.146-.285-.218-.427-.291-.177-.073-.337-.145-.497-.218-.16-.073-.32-.146-.498-.218.426 1.38.924 2.69 1.493 3.998a38.088 38.088 0 0 0 1.422 2.98Z",
    fill: "url(#icn_alphahq_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.294 11.395c.356-.146.782.073.924.436a.793.793 0 0 1-.64 1.018c-1.208.29-2.417.145-3.554-.291-.996-.364-1.778-1.018-2.418-1.745-.035.11-.053.237-.071.364a2.188 2.188 0 0 1-.071.363.738.738 0 0 1-.853.582c-.498-.146-.782-.727-.498-1.163.077-.138.154-.271.23-.402.204-.35.397-.681.552-1.052-1.209-2.399-.782-5.452 1.493-7.342a5.09 5.09 0 0 1 1.92-1.09c.071-.073.142 0 .142 0 .071 0 .071.072.071.145-.924 2.472-1.706 5.016-2.417 7.633a19.49 19.49 0 0 1-.214.945c1.21 1.526 3.271 2.326 5.404 1.599ZM5.237 1.363C3.957 1.8 2.89 2.745 2.25 3.98c-.783 1.6-.711 3.344-.072 4.798.427-.872.854-1.745 1.21-2.617.71-1.6 1.35-3.198 1.848-4.798Z",
    fill: "url(#icn_alphahq_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m11.067 11.25-.569-.291c-.284-.146-.64.072-.569.436l.072.727c0 .218.142.436.426.581.925.364 1.564-1.017.64-1.454Z",
    fill: "url(#icn_alphahq_svg__c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12.951 6.234c.018.127.036.254.036.363a6.972 6.972 0 0 1-.711 3.562.673.673 0 0 1-.996.364c-.322-.132-.352-.324-.408-.685a19.701 19.701 0 0 0-.018-.115c-.142-1.163-.427-2.253-.711-3.344h-.071a33.99 33.99 0 0 0-3.84-.218h-1.28c-.213 0-.213-.363 0-.363 1.636 0 3.342 0 4.977-.218-.127-.478-.28-.956-.428-1.419-.1-.311-.197-.615-.283-.908-.12-.308-.228-.616-.334-.919-.144-.411-.284-.812-.448-1.189-.07-.072.071-.145.143-.145a6.522 6.522 0 0 1 2.986 2.035c.07.146.213.364.284.437.036.036.071.09.107.145.035.054.07.109.107.145.142.146.213.291.284.436.035.11.089.219.142.328.053.109.107.218.142.327.071.145.143.29.143.363.07.146.142.436.142.654 0 .11.018.237.035.364Zm-1.244 2.035a6.4 6.4 0 0 0 .427-1.672v-.654c0-.654-.143-1.381-.427-1.963a.562.562 0 0 0-.142-.363 5.316 5.316 0 0 0-1.138-1.381c0-.049-.063-.097-.126-.146-.032-.024-.063-.048-.087-.072-.142-.146-.285-.218-.427-.291-.177-.073-.337-.145-.497-.218-.16-.073-.32-.146-.498-.218.426 1.38.924 2.69 1.493 3.998a38.088 38.088 0 0 0 1.422 2.98Z",
    stroke: "url(#icn_alphahq_svg__d)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8.294 11.395c.356-.146.782.073.924.436a.793.793 0 0 1-.64 1.018c-1.208.29-2.417.145-3.554-.291-.996-.364-1.778-1.018-2.418-1.745-.035.11-.053.237-.071.364a2.188 2.188 0 0 1-.071.363.738.738 0 0 1-.853.582c-.498-.146-.782-.727-.498-1.163.077-.138.154-.271.23-.402.204-.35.397-.681.552-1.052-1.209-2.399-.782-5.452 1.493-7.342a5.09 5.09 0 0 1 1.92-1.09c.071-.073.142 0 .142 0 .071 0 .071.072.071.145-.924 2.472-1.706 5.016-2.417 7.633a19.49 19.49 0 0 1-.214.945c1.21 1.526 3.271 2.326 5.404 1.599ZM5.237 1.363C3.957 1.8 2.89 2.745 2.25 3.98c-.783 1.6-.711 3.344-.072 4.798.427-.872.854-1.745 1.21-2.617.71-1.6 1.35-3.198 1.848-4.798Z",
    stroke: "url(#icn_alphahq_svg__e)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m11.067 11.25-.569-.291c-.284-.146-.64.072-.569.436l.072.727c0 .218.142.436.426.581.925.364 1.564-1.017.64-1.454Z",
    stroke: "url(#icn_alphahq_svg__f)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icn_alphahq_svg__a",
    x1: 10.749,
    y1: 12.713,
    x2: 10.749,
    y2: 10.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A68AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icn_alphahq_svg__b",
    x1: 10.749,
    y1: 12.713,
    x2: 10.749,
    y2: 10.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A68AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icn_alphahq_svg__c",
    x1: 10.749,
    y1: 12.713,
    x2: 10.749,
    y2: 10.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A68AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icn_alphahq_svg__d",
    x1: 10.749,
    y1: 12.895,
    x2: 10.749,
    y2: 10.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A68AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icn_alphahq_svg__e",
    x1: 10.749,
    y1: 12.895,
    x2: 10.749,
    y2: 10.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A68AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icn_alphahq_svg__f",
    x1: 10.749,
    y1: 12.895,
    x2: 10.749,
    y2: 10.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A68AF"
  })))));
};
export default SvgIcnAlphahq;